import { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from "prop-types";
import { DatePicker, Input, Modal, Radio, Select, Tag } from 'antd';
import { saveAyantDroit, updateAyantDroit } from '../../../../../hooks/useHooks';
import { toast } from 'react-toastify';
import { ExclamationCircleFilled } from '@ant-design/icons';
import dayjs from 'dayjs';
const { confirm } = Modal;

const AddAyantDroit = (props) => {
    const [ayantDroit, setAyantDroit] = useState(props?.ayantDroit);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

    const dragDataRef = useRef({ startX: 0, startY: 0, dragging: false });
    const modalContainerRef = useRef(null);

    const handleMouseMove = useCallback((event) => {
        if (!dragDataRef.current.dragging) {
            return;
        }
        setModalPosition({
            x: event.clientX - dragDataRef.current.startX,
            y: event.clientY - dragDataRef.current.startY,
        });
    }, []);

    const handleMouseUp = useCallback(() => {
        if (!dragDataRef.current.dragging) {
            return;
        }
        dragDataRef.current.dragging = false;
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
    }, [handleMouseMove]);

    const handleTouchMove = useCallback((event) => {
        if (!dragDataRef.current.dragging) {
            return;
        }
        if (event.touches.length !== 1) {
            return;
        }
        const touch = event.touches[0];
        setModalPosition({
            x: touch.clientX - dragDataRef.current.startX,
            y: touch.clientY - dragDataRef.current.startY,
        });
        event.preventDefault();
    }, []);

    const handleTouchEnd = useCallback(() => {
        if (!dragDataRef.current.dragging) {
            return;
        }
        dragDataRef.current.dragging = false;
        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleTouchEnd);
        window.removeEventListener('touchcancel', handleTouchEnd);
    }, [handleTouchMove]);

    const handleMouseDown = useCallback((event) => {
        if (event.button !== 0) {
            return;
        }
        const headerNode = modalContainerRef.current?.querySelector('.ant-modal-header');
        const closeNode = modalContainerRef.current?.querySelector('.ant-modal-close');
        if (!headerNode || !headerNode.contains(event.target) || (closeNode && closeNode.contains(event.target))) {
            return;
        }
        dragDataRef.current = {
            startX: event.clientX - modalPosition.x,
            startY: event.clientY - modalPosition.y,
            dragging: true,
        };
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
        event.preventDefault();
    }, [modalPosition, handleMouseMove, handleMouseUp]);

    const handleTouchStart = useCallback((event) => {
        if (event.touches.length !== 1) {
            return;
        }
        const headerNode = modalContainerRef.current?.querySelector('.ant-modal-header');
        const closeNode = modalContainerRef.current?.querySelector('.ant-modal-close');
        if (!headerNode || !headerNode.contains(event.target) || (closeNode && closeNode.contains(event.target))) {
            return;
        }
        const touch = event.touches[0];
        dragDataRef.current = {
            startX: touch.clientX - modalPosition.x,
            startY: touch.clientY - modalPosition.y,
            dragging: true,
        };
        window.addEventListener('touchmove', handleTouchMove, { passive: false });
        window.addEventListener('touchend', handleTouchEnd);
        window.addEventListener('touchcancel', handleTouchEnd);
        event.preventDefault();
    }, [modalPosition, handleTouchMove, handleTouchEnd]);

    const handleChange = (e, nom) => {
        if (nom === 'profession') {
            console.log('profession ', e);
            setAyantDroit({ ...ayantDroit, profession: e?.target?.value });
        } else {
            if (nom) {
                setAyantDroit({ ...ayantDroit, [nom]: e });
            } else {
                const { name, value } = e.target;
                setAyantDroit({ ...ayantDroit, [name]: value.toUpperCase() });
            }
        }

    };

    useEffect(() => {
        setIsModalVisible(props.open);
        if (props.open) {
            console.log('props.ayantDroit ', props.ayantDroit);
            props.ayantDroit && setAyantDroit({ ...props.ayantDroit, sexe: props.ayantDroit?.genre || props.ayantDroit?.sexe, dateNaissance: props.ayantDroit?.dateNaissance ? dayjs(props.ayantDroit?.dateNaissance) : null });
            setModalPosition({ x: 0, y: 0 });
        } else {
            dragDataRef.current.dragging = false;
        }
    }, [props.open]);

    useEffect(() => {
        if (!isModalVisible) {
            props.setOpen(false);
        }
    }, [isModalVisible]);

    const handleSave = async () => {
        try {
            console.log("aDN ", ayantDroit?.dateNaissance);

            if (ayantDroit?.dateNaissance) {
                ayantDroit.dateNaissance = ayantDroit.dateNaissance.format('YYYY-MM-DD');
            }

            ayantDroit.victime = props.victime?.codeId;
            console.log('victimeFormik ', ayantDroit);
            setUpdateLoading(true);

            console.log('victime ', ayantDroit);
            console.log('edit ', props.edit);
            if (props.edit) {
                const response = await updateAyantDroit(ayantDroit);
                console.log('response ', response);
            } else {
                const response = await saveAyantDroit(ayantDroit);
                console.log('response ', response);
            }


            setIsModalVisible(false);
            // setRefetch((previous) => !previous)
            toast.success('Ayant droit enregistré avec succès!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            window.location.reload();
        } catch
        (error) {
            console.error('Erreur lors de la sauvegarde de l\'ayant droit : ', error);
            toast.error('Une erreur est survenue', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            })
        } finally {
            setUpdateLoading(false)
        }

    };

    const handleClose = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {
        const headerNode = modalContainerRef.current?.querySelector('.ant-modal-header');
        if (headerNode) {
            headerNode.style.cursor = 'move';
            headerNode.style.userSelect = 'none';
            headerNode.style.touchAction = 'none';
        }
    }, [isModalVisible]);

    useEffect(() => () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleTouchEnd);
        window.removeEventListener('touchcancel', handleTouchEnd);
    }, [handleMouseMove, handleMouseUp, handleTouchMove, handleTouchEnd]);


    return (
        <Modal
            title={props.edit ? "Modifier l'Ayant droit" : "Enregistrer un ayant droit"}
            open={isModalVisible}
            confirmLoading={updateLoading}
            loading={updateLoading}
            modalRender={(modalNode) => (
                <div
                    ref={modalContainerRef}
                    className="draggable-ayant-droit-modal"
                    onMouseDown={handleMouseDown}
                    onTouchStart={handleTouchStart}
                    style={{
                        transform: `translate(${modalPosition.x}px, ${modalPosition.y}px)`,
                        transition: 'none',
                    }}
                >
                    {modalNode}
                </div>
            )}
            onOk={() => {
                if (ayantDroit.nom.trim().toUpperCase() !== props?.victime?.personne?.nom?.trim()?.toUpperCase()) {
                    confirm({
                        title: "Le nom de l'ayant droit ne correspond pas au nom de la victime",
                        icon: <ExclamationCircleFilled />,
                        content: "Voulez-vous quand-même l'enregistrer?",
                        okText: "Oui",
                        okType: "danger",
                        cancelText: "Non",
                        onOk() {
                            handleSave();
                        },
                        onCancel() {
                            console.log("Cancel");
                        },
                    });
                } else {
                    handleSave();
                }
            }}
            onCancel={handleClose}
            okText="Sauvegarder"
            cancelText="Annuler"
            width={"1000px"}
            zIndex={2000}
            okButtonProps={{ style: { background: '#242166' } }}
        >
            Ayant Droit de la victime : <Tag color='blue'>{props.victime?.personne?.nom} {props.victime?.personne?.prenom}</Tag>
            <div className="row">
                <div className="col-4">
                    <label
                        htmlFor="qualite"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                            width: "100%"
                        }}
                    > Qualité de l'ayant droit *
                    </label>
                    <Select
                        label={`Qualité de l'ayant droit`}
                        name={"qualite"}
                        value={ayantDroit?.qualite || ""}
                        onChange={(event) => handleChange(event, "qualite")}
                        options={[
                            { value: "PERE", label: "PERE" },
                            { value: "MERE", label: "MERE" },
                            { value: "CONJOINT", label: "CONJOINT(E)" },
                            { value: "CONCUBIN", label: "CONCUBIN(E)" },
                            { value: "ENFANT", label: "ENFANT" },
                            { value: "FRERE", label: "FRERE" },
                            { value: "SOEUR", label: "SOEUR" },
                        ]}
                        style={{ width: "100%" }}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="nom"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                        }}
                    > Nom de l'ayant droit
                    </label>
                    <Input
                        placeholder={`Nom de l'ayant droit`}
                        name={"nom"}
                        value={ayantDroit?.nom || ""}
                        onChange={(event) => handleChange(event)}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="prenom"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                        }}
                    > Prénoms de l'ayant droit
                    </label>
                    <Input
                        placeholder={`Prénoms de l'ayant-droit`}
                        name={"prenom"}
                        value={ayantDroit?.prenom || ""}
                        onChange={(event) => handleChange(event)}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="sexe"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                            width: "100%"
                        }}
                    > Sexe de l'ayant droit *
                    </label>
                    <Select
                        placeholder={`Sexe de l'ayant droit`}
                        name={"sexe"}
                        defaultValue={props?.edit ? ayantDroit?.genre : ayantDroit?.sexe || ""}
                        value={ayantDroit?.sexe}
                        onChange={(event) => handleChange(event, "sexe")}
                        options={[
                            { value: "MASCULIN", label: "MASCULIN" },
                            { value: "FEMININ", label: "FEMININ" },
                        ]}
                        style={{ width: "100%" }}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="dateNaissance"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                        }}
                    > Date de naissance de l'ayant droit *
                    </label>
                    <DatePicker
                        label={`Date de naissance de l'ayant droit`}
                        name={"dateNaissance"}
                        value={props?.edit ? dayjs(ayantDroit?.dateNaissance) : ayantDroit?.dateNaissance || ""}
                        onChange={(event) => handleChange(event, "dateNaissance")}
                        style={{ width: "100%" }}
                        disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                </div>
                <div className="col-4">
                    <label
                        htmlFor="adresse"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                        }}
                    > Adresse de l'ayant droit
                    </label>
                    <Input
                        placeholder={`Adresse de l'ayant droit`}
                        name={"adresse"}
                        type="text"
                        value={ayantDroit?.adresse || ""}
                        onChange={(event) => handleChange(event)}
                    />
                </div>
                {/* Checkbox if ayantDroit.qualite.startsWith("ENFANT"), to check if "ELEVE/ETUDIANT" */}
                {ayantDroit?.qualite?.startsWith("ENFANT") && <div className="col-4">
                    <label
                        htmlFor="profession"
                        style={{
                            margin: "10px 0 10px 0",
                            // margin: "30px 0 10px 0", --- IGNORE ---
                            color: null,
                        }}
                    > Scolarisé ? *
                    </label>
                    <Radio.Group
                        name={"profession"}
                        onChange={(event) => handleChange(event, "profession")}
                        value={ayantDroit?.profession === "ELEVE" ? "ETUDIANT" : ayantDroit?.profession}
                    >
                        <Radio value="ETUDIANT">OUI</Radio>
                        <Radio value="NON_ETUDIANT">NON</Radio>
                    </Radio.Group>
                </div>}
            </div>

        </Modal>
    )
}
AddAyantDroit.propTypes = {
    open: PropTypes.bool,
    ayantDroit: PropTypes.object,
    edit: PropTypes.bool,
    setOpen: PropTypes.func,
};

export default AddAyantDroit
